import React,{useState} from 'react';
import { Link, useHistory } from "react-router-dom";
import "./admin_signin.css";
import axios from 'axios';
import Swal from 'sweetalert2';
import { var_api } from '../../constant';
import Spinner from 'react-bootstrap/Spinner';
import shop_logo from "../../../images/splash/herbal.jpeg";
import { Card, CardImg, CardTitle, CardText, CardColumns,
  CardSubtitle, CardBody, Tooltip } from 'reactstrap';


const AdminSignin = () => {
  
    const history = useHistory(); 
  const [message, setMessage] = useState('');
  const [ postloading,setPostLoading ] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  // Validation state
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };

  const validateForm = () => {
    let isValid = true;

    // Email validation
    if (!email) {
      setEmailError("Email is required.");
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError("Enter a valid email.");
      isValid = false;
    } else {
      setEmailError("");
    }

    // Password validation
    if (!password) {
      setPasswordError("Password is required.");
      isValid = false;
    } else {
      setPasswordError("");
    }

    return isValid;
  };

  const handleSignIn = async (e) => {
    e.preventDefault();

    // Check form validity
    if (!validateForm()) return;

    try {
      const loginResponse = await axios.post(`${var_api}super-admin/signin`, {
        email,
        password,
      });

      const { token, id } = loginResponse.data;

      // Update token
      await axios.put(`${var_api}update-super-admin-token/${id}/${email}`, {
        admin_id: id,
        email,
        token,
      });

      localStorage.setItem("SAtoken", token);
      localStorage.setItem("SAShopId", id);

      await Swal.fire({
        icon: "success",
        title: "Success",
        text: "Login successful!",
      });

      history.push('/superadmin-dashboard');
    } catch (error) {
      console.error("Error during login or token update:", error);
      await Swal.fire({
        icon: "error",
        title: `${error.response.data.message}`,
        text: "Failed to login . Please try again.",
      });
    }
  };

    const handleGoSuperAdmin = () => {
      history.push('/signin');
    }


   return(
    <div className="superadminsign-up">
       {/* <Tooltip
        isOpen={tooltipOpen}
        target="adminButton" // Specify the target ID of the button
        toggle={toggleTooltip}
      >
        Admin
      </Tooltip>
    <button className="btn btn-danger m-2" id="adminButton" onClick={()=>{handleGoSuperAdmin(); toggleTooltip();}}><i class="bi bi-person"></i></button> */}
      <br/>
      <br/>
      <br/>
      <Card style={{width:"27rem",height:"35rem",padding:"10px",borderRadius:"25px",border:"none", display: "flex", justifyContent: "center", alignItems: "center",margin:"auto" }}>
    <CardBody>
      <CardTitle style={{textAlign:"center"}}> 
      <Link to="/" className="navbar-brand">
      <img src={shop_logo} alt="logo" style={{margin:"auto", width:"100px",height:"100px",borderRadius:"50px"}} />
    </Link>
      </CardTitle>
      <CardSubtitle>
            <div className="container" id="containdiv">
            <form className="py-2" onSubmit={handleSignIn}>
  <h6
    className="lead text-left py-2"
    style={{
      fontSize: "14px",
      fontWeight: "bold",
      fontFamily: "sans-serif",
    }}
  >
    Login
  </h6>

  {/* Email Field */}
  <div className="form-group">
    <label className="form-label text-danger fw-bold m-0">Email</label>
    <input
      type="email"
      className={`form-control ${emailError ? "is-invalid" : ""}`}
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Email"
      required
      style={{
        height: "45px",
        borderRadius: "20px",
        padding: "0 15px",
        boxSizing: "border-box",
      }}
    />
    {emailError && <div className="invalid-feedback">{emailError}</div>}
  </div>
  <br />

  {/* Password Field */}
  <div className="form-group">
    <label className="form-label text-danger fw-bold m-0">Password</label>
    <div
      className="input-group"
      style={{
        position: "relative",
      }}
    >
      <input
        type={showPassword ? "text" : "password"}
        className={`form-control ${passwordError ? "is-invalid" : ""}`}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Password"
        required
        style={{
          height: "45px",
          borderRadius: "20px",
          paddingRight: "50px", // Leaves space for the button
          paddingLeft: "15px",
          boxSizing: "border-box",
        }}
      />
      <button
        type="button"
        className="btn"
        onClick={() => setShowPassword(!showPassword)}
        style={{
          position: "absolute",
          top: "40%",
          right: "10px",
          transform: "translateY(-50%)",
          backgroundColor: "transparent",
          border: "none",
          fontSize: "20px",
          cursor: "pointer",
          zIndex: 10, // Ensures the button stays above the input
        }}
      >
        {showPassword ? (
          <i className="bi bi-eye-slash-fill"></i>
        ) : (
          <i className="bi bi-eye-fill"></i>
        )}
      </button>
    </div>
    {passwordError && <div className="invalid-feedback">{passwordError}</div>}
  </div>
  <br />

  <div className="d-grid">
    <button className="btn btn-danger btn-block" type="submit">
      Login
    </button>
  </div>
</form>

            </div>
          </CardSubtitle>
     
     </CardBody>
   </Card>
</div>
    
    // <div className="signin-container">
    //     <div className='signinbox'>
    //         <div className="left-section">
            
    //         </div>
    //         <div className="right-section">
    //         <div style={{width:"350px",margin:"auto",marginTop:"100px"}}>
    //             <h2 style={{textAlign:"center",fontFamily:"serif",fontWeight:"bolder"}}>Login</h2>
    //             <form className="py-2" onSubmit={handleSignIn} >
    //                 <div className="form-group">
    //                     <label htmlFor="username" style={{color:"rgb(9, 242, 199)",fontWeight:"bold",padding:"5px",fontSize:"20px"}}>Email</label>
    //                     <input
    //           type="email"
    //             name="email"
    //             className="form-control"
    //             value={email}
    //             onChange={(e) => setEmail(e.target.value)}
    //             placeholder="Email"
    //             style={{height:"10px"}}
    //             required
    //           />
    //                 </div>
    //                 <br/>
    //                 <div className="form-group">
    //                     <label htmlFor="password" style={{color:"rgb(9, 242, 199)",fontWeight:"bold",padding:"5px",fontSize:"20px"}}>Password</label>
    //                     <input
    //             type="password"
    //             name="password"
    //             className="form-control"
    //             value={password}
    //             onChange={(e) => setPassword(e.target.value)}
    //             placeholder="Password"
    //             style={{height:"10px"}}
    //             required
    //           />
    //                 </div>
    //                 <br/>
    //                 <div className="d-grid">
    //           <button className="btn btn-success btn-block" style={{backgroundColor:"rgb(9, 242, 199)",borderColor:"rgb(9, 242, 199)"}} type="submit" disabled={postloading}>
    //           {postloading ? (
    //       <Spinner
    //         as="span"
    //         animation="border"
    //         size="sm"
    //         role="status"
    //         aria-hidden="true"
    //       />
    //     ) : (
    //       'Login'
    //     )}
    //           </button>
    //         </div>
    //             </form>
    //             {message && <p>{message}</p>}
    //         </div>
    //         </div>

    //     </div>
   
    // </div>

    )

    }

 export default AdminSignin;
